import React from 'react'
import NextImage from 'next/image'

import { Separator } from '@wartek-id/separator'
import { Text } from '@wartek-id/text'

import { EmptyStateWithAction } from 'app/ProfileRevampPage/components/EmptyState'
import {
  TXT_DEFAULT_NO_KARYA,
  BUKTI_KARYA_CATEGORIES,
} from 'app/ProfileRevampPage/constants'
import { useProfile } from 'app/ProfileRevampPage/hooks/useProfile'
import { useLayoutState } from 'app/ProfileRevampPage/hooks/useLayoutState'
import ListItem from 'app/ProfileRevampPage/components/SectionKarya/BuktiKarya/ListItem'
import { useSETrackEvent } from 'app/ProfileRevampPage/hooks/useSETrackEvent'

const BUKTI_KARYA_CATEGORY_KEYS = Object.keys(BUKTI_KARYA_CATEGORIES)

const BuktiKaryaSection = (props: React.HTMLAttributes<HTMLDivElement>) => {
  const { isCurrentUser, profileId, profileData } = useProfile()
  const { hasBuktiKarya } = useLayoutState()
  const { SETrackClickEmptyStateBuktiKarya } = useSETrackEvent()

  return (
    <div className="px-4 py-6" {...props}>
      <div className="flex space-x-2 items-center mb-3">
        <NextImage
          layout="fixed"
          src="/icon/menu-bukti-karya-saya.svg"
          alt="Bukti Karya"
          width="24px"
          height="24px"
        />
        <Text variant="heading-md">Bukti Karya</Text>
      </div>

      {hasBuktiKarya ? (
        <div>
          {(profileData?.buktiKarya ?? [])
            .sort((a, b) => {
              if (BUKTI_KARYA_CATEGORY_KEYS?.indexOf?.(a.category) === -1) {
                return (profileData?.buktiKarya ?? []).length
              }

              if (a.category === 'KARYA_LAINNYA') {
                return (profileData?.buktiKarya ?? []).length - 1
              }

              return (
                BUKTI_KARYA_CATEGORY_KEYS?.indexOf?.(a.category) -
                BUKTI_KARYA_CATEGORY_KEYS?.indexOf?.(b.category)
              )
            })
            .map(({ category, count = 0 }) => {
              // hide empty Category when viewed by other than current user (self)
              if (!isCurrentUser && count === 0) {
                return null
              }

              return (
                <div key={category}>
                  <ListItem
                    data-testid="profile-bukti-karya-list-item"
                    category={category}
                    subtitle={
                      !!Number(count) ? `${count} karya` : TXT_DEFAULT_NO_KARYA
                    }
                    href={`/profil/${profileId}/bukti-karya/${category}/`}
                  />
                  <Separator />
                </div>
              )
            })}
        </div>
      ) : (
        <EmptyStateWithAction
          data-testid="profile-empty-state-bukti-karya"
          description="Belum ada Bukti Karya yang Anda unggah. Kalau ada, akan muncul di sini."
          actionText="Cara unggah Bukti Karya"
          actionPath={
            process.env.NEXT_PUBLIC_PUSAT_INFORMASI_RUMDIK_BASE_URL +
            '/hc/id/articles/52515879684505-Tahapan-dalam-Pembuatan-Karya'
          }
          className="p-3 bg-surface-neutral-subdued rounded-[4px]"
          onActionButtonClicked={SETrackClickEmptyStateBuktiKarya}
        />
      )}
    </div>
  )
}

export default BuktiKaryaSection
